import { PUBLIC_URL } from '../../utils/constants';

export default {
  CALCULATOR_LISTING: `${PUBLIC_URL}/calculators/list`,
  ADD_CALCULATOR: `${PUBLIC_URL}/calculator/add`,
  EDIT_CALCULATOR: `${PUBLIC_URL}/calculator/edit/:id`,
};
